import LoansLayout from 'layout/loans/loansLayout'
import { RouteObject } from 'react-router-dom'
import RequestedLoans from './requestedLoans'
import AddLoan from './add'
import LoanRequestWizard from './request'
import DepositPage from './deposit'
import Transaction from './transaction'
import WithDraw from './withDraw'
import Final from './withDraw/final'
import AddNewManagementLoan from './manager/addNew'
import GrantLoanWizard from './manager/grant'
import ManagementAddNewFinal from './manager/addNewFinal'
import FinalAdd from './manager/finalAdd'
import AddOldStepOne from './manager/old/stepOne'
import StepTwo from './manager/old/stepTwo'
import FinalOldAdd from './manager/old/final'
import AcceptAddNewManagementLoan from './requestedLoans/tabs/requested/aceept'
import ErrorBug from 'components/errors/bugs'

export const loansRoutes: RouteObject[] = [
    {
        path: '/loans',
        element: <LoansLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: false,
                path: 'requested-loans/:id',
                element: <RequestedLoans />,
            },
            {
                // درخواست وام as a step-by-step wizard. A manager gets an
                // extra first step — «برای کیست؟» — which is the PWA half of
                // the manager-files-on-behalf gap Android never had.
                index: false,
                path: 'request/:id',
                element: <LoanRequestWizard />,
            },
            {
                // the previous single-form screen. Still routed: the
                // accept-a-request flow links into it and a bundle cached at
                // the CDN can still navigate here.
                index: false,
                path: 'add/:id',
                element: <AddLoan />,
            },
            {
                index: false,
                path: 'deposit/:id',
                element: <DepositPage />,
            },
            {
                index: false,
                path: 'transaction',
                element: <Transaction />,
            },
            {
                index: false,
                path: 'withDraw/:id/:poolShip',
                element: <WithDraw />,
            },
            {
                index: false,
                path: 'withDraw/final',
                element: <Final />,
            },
            {
                // اعطای وام as a step-by-step wizard, starting with WHO
                index: false,
                path: 'management/grant/:id',
                element: <GrantLoanWizard />,
            },
            {
                // the previous single-form screen. Still routed: the
                // «accept a loan request» flow links straight into it, and
                // an old bundle cached at the CDN can still navigate here.
                index: false,
                path: 'management/add-new/:id/:poolShip',
                element: <AddNewManagementLoan />,
            },
            {
                index: false,
                path: 'add-new/management/final',
                element: <ManagementAddNewFinal />,
            },
            {
                index: false,
                path: 'add-new/management/final/add',
                element: <FinalAdd />,
            },
            {
                index: false,
                path: 'management/add-old/:id/:poolShip',
                element: <AddOldStepOne />,
            },
            {
                index: false,
                path: 'add-old/management/installments',
                element: <StepTwo />,
            },
            {
                index: false,
                path: 'add-old/management/final/add',
                element: <FinalOldAdd />,
            },
            {
                index: false,
                path: 'accept/management/add-new/:id/:poolShip',
                element: <AcceptAddNewManagementLoan />,
            },
        ],
    },
]
